import './style.sass';

import React from 'react';

import CrewContainer from '../../layouts-components__common-cases/crew-container';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const team = {
    crewList: [
        {
            crewItemImg: '',
            crewItemTitle: 'Никита Булахтин',
            crewItemSubtitle: 'Менеджер проекта',
        },
        {
            crewItemImg: '',
            crewItemTitle: '3 PPC-специалиста',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Дизайнер',
            crewItemSubtitle: '',
        },
    ],
};

const Team: React.FC  = () => (
    <div className="ck10-team">
        <FullWrapper>
            <div className="ck10-team__Title">Команда</div>
            <CrewContainer container={team} />
        </FullWrapper>
    </div>
);

export default Team;